import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      light: '#fff',
      main: '#e0e4e4',
      dark: '#f0f4f4',
      contrastText: '#000',
    },
    secondary: {
      light: '#856ed1',
      main: '#7864bc',
      dark: '#5b4b8e',
      contrastText: '#fff',
    },
  },
  typography: {
    allVariants: {
      color: '#58666e',
    },
    h1: { color: '#000' },
    h2: { color: '#000' },
    h3: { color: '#000' },
    h4: { color: '#000' },
    h5: { color: '#000' },
    h6: { color: '#000' },
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: { fontSize: '14px' },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: { fontSize: '14px' },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        color: 'secondary',
      },
    },
    // The theme's primary palette is a light grey used for backgrounds, so
    // any component that defaults color="primary" renders as near-invisible
    // grey on white. Force the secondary (purple) palette on interactive
    // components where the selected / indicator state needs to be visible.
    MuiTabs: {
      defaultProps: {
        textColor: 'secondary',
        indicatorColor: 'secondary',
      },
    },
    MuiRadio: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiSwitch: {
      defaultProps: {
        color: 'secondary',
      },
    },
  },
});
